import Icon from "@components/Atoms/Icon";
import ModalToOpenService from "@core-ui/ContextServices/ModalToOpenService/ModalToOpenService";
import ModalToOpen from "@core-ui/ContextServices/ModalToOpenService/model/ModalsToOpen";
import type PropsEditor from "@ext/item/actions/propsEditor/components/PropsEditor";
import type { PropsEditorTarget } from "@ext/item/actions/propsEditor/logic/usePropsEditorSubmit";
import t from "@ext/localization/locale/translate";
import { DropdownMenuItem } from "@ui-kit/Dropdown";
import type { ComponentProps, FC } from "react";

interface PropsEditorTriggerProps extends PropsEditorTarget {
	onOpenChange?: (open: boolean) => void;
}

const PropsEditorTrigger: FC<PropsEditorTriggerProps> = ({ onOpenChange, ...target }) => {
	const onClick = () => {
		ModalToOpenService.setValue<ComponentProps<typeof PropsEditor>>(ModalToOpen.ItemPropsEditor, {
			...target,
			onClose: () => {
				ModalToOpenService.resetValue();
				onOpenChange?.(false);
			},
		});
		onOpenChange?.(true);
	};

	return (
		<DropdownMenuItem onSelect={onClick}>
			<Icon code="pencil" />
			{t("configure")}
		</DropdownMenuItem>
	);
};

export default PropsEditorTrigger;
